import React from 'react'
import Button from '../components/Button'
import Popup from '../components/Popup'
import RadioButtonGroup from '../components/RadioButtonGroup'
import './DownloadListPopup.scss'

interface Props {
  onClose: () => void
  onSubmit: (value: DownloadListFormats) => void
}

export enum DownloadListFormats {
  default = 'default',
  aroflow = 'aroflow',
  tradify = 'tradify',
  simpro = 'simpro',
  serviceM8 = 'serviceM8',
}

const DownloadListPopup: React.FunctionComponent<Props> = (props) => {
  const allListFormats = [{
    key: DownloadListFormats.default,
    label: 'Default (.csv)'
  }, {
    key: DownloadListFormats.aroflow,
    label: 'Aroflow (.csv)'
  }, {
    key: DownloadListFormats.tradify,
    label: 'Tradify (.csv)'
  }, {
    key: DownloadListFormats.simpro,
    label: 'Simpro (.csv)'
  }, {
    key: DownloadListFormats.serviceM8,
    label: 'ServiceM8 (.csv)'
  }]

  const { onClose, onSubmit } = props
  const [formatType, setFormatType] = React.useState<DownloadListFormats | null>(DownloadListFormats.default)

  const onSelect = (value: DownloadListFormats | null) => {
    setFormatType(value)
  }

  return (
    <Popup onClose={onClose}>
      <div className="DownloadListPopup">
        <h3>Download your List</h3>
        <div className="downloadListOptions">
          <RadioButtonGroup
            options={allListFormats}
            onSelect={option => { onSelect(option?.key || null) }}
            selected={formatType}
          />
        </div>
        <div className="buttonRow">
          <Button buttonStyle="redStroke" onClick={onClose}>Cancel</Button>
          <Button
            buttonStyle="green"
            disabled={!formatType}
            onClick={() => formatType && onSubmit(formatType)}
          >
            Download
          </Button>
        </div>
      </div>
    </Popup>
  )
}

export default DownloadListPopup